/*
 * @Author: ljc_625738144@qq.com
 * @Date: 2023-09-27 15:43:16
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-09-02 13:55:22
 * @Description:
 * @FilePath: \haozhang_pro\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from '@/store/index';
import router from './router'
import vueCookie from 'vue-cookies'
import 'xe-utils'
import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table/lib/index.css'
import "babel-polyfill"
import '@/assets/css/common.less';
// import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/theme/index.css";
import '@/assets/utils/function'
import util from '@/assets/utils/index'
import ElementUI from 'element-ui';
import axios from '@/assets/utils/https';
import { apiUrl } from '@/assets/js/apiConfig';
import accBtn from "@/components/accBtn"
import lodash from "lodash"
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
// import 'default-passive-events' // 注释掉为了解决编辑器拖拽报错的问题
// 大数据加载
import loadmore from '@/assets/utils/randerTable.js'
// 视频播放
import VideoPlayer from 'vue-video-player'
// 加密
import CryptoJS from 'crypto-js'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(VideoPlayer)
Vue.$rootUrl = Vue.prototype.$rootUrl = apiUrl.haozhang;
import clipboard from 'clipboard';  // copy
//注册到vue原型上
Vue.prototype.clipboard = clipboard;
//自定义按键
Vue.config.keyCodes.f7 = 118;	//F7
Vue.config.keyCodes.f6 = 117;	//F6
Vue.config.keyCodes.equal = 187; //=

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.$util = Vue.prototype.$util = util
Vue.$lodash = Vue.prototype.$lodash = lodash; // 挂载 lodash
Vue.use(ElementUI);
Vue.use(vueCookie);
Vue.use(VXETable);
Vue.use(Viewer);
VXETable.use(VXETablePluginElement);
if(sessionStorage.getItem('menu')){
	store.commit('ADDROUTECHILD',JSON.parse(sessionStorage.getItem('menu')));
}

Vue.directive('focus', {
  inserted: function (el) {
    el.querySelector('input').focus();
  }
})

// 挂载websocket
import webSocket from "./assets/utils/webSocket.js";
Vue.prototype.$webSocket = webSocket;

var object = {
    time:(new Date()).getTime()
};
let datas = apiUrl.socketUrl + '?datas='+btoa(aesMinEncrypt(JSON.stringify(object)));
//setInterval(()=>{
  // console.log(webSocket.webSocket)
  webSocket.initWebSocket(datas);
//},3000)
// 加密函数
function aesMinEncrypt(word){
    var _word = CryptoJS.enc.Utf8.parse(word),
        _key = CryptoJS.enc.Utf8.parse("3g-,1~lde^[w`S&5"),
        _iv = CryptoJS.enc.Utf8.parse("%JL<&*l.FsS?:}#1");
    var encrypted = CryptoJS.AES.encrypt(_word, _key, {
                iv: _iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
        });
    return encrypted.toString();
}
/* eslint-disable no-new */
// 表格大数据渲染自定义
Vue.directive(loadmore.name,loadmore.componentUpdated)
// 全局组件
Vue.component('accBtn', accBtn);
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js